/* =========================================
   KYRA — SIZE GUIDE MODAL
   Funziona anche con contenuti caricati dopo
   es. Quick View
========================================= */

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-size-guide-modal]');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.classList.add('dr-size-guide-lock');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('dr-size-guide-lock');
  }

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-size-guide-open]');
    const closeBtn = event.target.closest('[data-size-guide-close]');

    if (openBtn) {
      event.preventDefault();
      openModal();
    }

    if (closeBtn) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
});